import { Mail, MapPin, Phone } from "lucide-react";
import { CONTACT, HOURS } from "@/data/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Hours = () => {
  const today = new Date().getDay();

  return (
    <section
      id="horaires"
      data-testid="hours-section"
      className="relative overflow-hidden bg-[#12281D] py-24 text-[#F5F0E6] lg:py-32"
    >
      <span
        aria-hidden="true"
        className="text-outline-cream pointer-events-none absolute -bottom-10 left-0 hidden select-none font-display text-[12rem] font-semibold leading-none lg:block"
      >
        Rennes
      </span>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 sm:px-8 lg:grid-cols-2 lg:gap-12">
        <div>
          <Reveal>
            <Eyebrow light>Horaires &amp; adresse</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2
              data-testid="hours-title"
              className="mt-6 font-display text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl"
            >
              Poussez la porte,
              <br />
              on vous <em className="italic text-[#D4A359]">attend</em>.
            </h2>
          </Reveal>

          <Reveal delay={0.2}>
            <ul data-testid="hours-list" className="mt-12 divide-y divide-[#F5F0E6]/10">
              {HOURS.map((row) => {
                const isToday = row.match(today);
                return (
                  <li
                    key={row.day}
                    data-testid={`hours-row-${row.day.toLowerCase().replace(/[^a-z]/g, "-")}`}
                    className={`flex items-center justify-between gap-4 py-5 transition-colors ${
                      isToday ? "-mx-4 rounded-xl bg-[#F5F0E6]/5 px-4" : ""
                    }`}
                  >
                    <span className="flex items-center gap-3 font-display text-lg font-medium sm:text-xl">
                      {row.day}
                      {isToday && (
                        <span
                          data-testid="hours-today-badge"
                          className="rounded-full bg-[#C85A32] px-3 py-1 font-mono text-[9px] font-medium uppercase tracking-[0.18em] text-[#FAF7F2]"
                        >
                          Aujourd'hui
                        </span>
                      )}
                    </span>
                    <span
                      className={`font-mono text-xs uppercase tracking-[0.16em] sm:text-sm ${
                        row.hours === "Fermé" ? "text-[#F5F0E6]/40" : "text-[#D4A359]"
                      }`}
                    >
                      {row.hours}
                    </span>
                  </li>
                );
              })}
            </ul>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center lg:pl-10">
          <Reveal delay={0.15}>
            <div
              data-testid="address-card"
              className="rounded-[28px] border border-[#F5F0E6]/12 bg-[#F5F0E6]/[0.04] p-8 backdrop-blur-sm sm:p-10"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#C85A32]/15 text-[#C85A32]">
                <MapPin size={20} />
              </span>
              <p className="mt-7 font-display text-3xl font-semibold leading-tight sm:text-4xl">
                {CONTACT.address}
              </p>
              <p className="mt-1 font-display text-2xl text-[#F5F0E6]/70">{CONTACT.city}</p>
              <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-[#F5F0E6]/60">
                À deux pas du marché des Lices, entre la place du Parlement et
                la cathédrale Saint-Pierre. Terrasse ouverte dès les beaux
                jours.
              </p>

              <div className="mt-8 space-y-3 border-t border-[#F5F0E6]/10 pt-8">
                <a
                  href={`tel:+33${CONTACT.phone.replace(/\s/g, "").slice(1)}`}
                  data-testid="contact-phone-link"
                  className="group flex items-center gap-3 font-mono text-sm tracking-[0.08em] text-[#F5F0E6]/80 transition-colors hover:text-[#D4A359]"
                >
                  <Phone size={15} className="text-[#C85A32]" />
                  {CONTACT.phone}
                </a>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="contact-email-link"
                  className="group flex items-center gap-3 font-mono text-sm tracking-[0.08em] text-[#F5F0E6]/80 transition-colors hover:text-[#D4A359]"
                >
                  <Mail size={15} className="text-[#C85A32]" />
                  {CONTACT.email}
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
